export default __webpack_public_path__ + "static/media/file-web_darkGray1.7457c753.svg";